"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLabelsFragmentIntoRenderProps = void 0;
const catalog_messages_1 = require("@tableau/catalog-messages");
const LabelHelpers_1 = require("../../LabelHelpers");
const LabelCategories_1 = require("../../shared/LabelCategories");
function urlForContentType(siteUrls, contentType, id, parentId, parentType) {
    if (!siteUrls || !contentType || !id) {
        return undefined;
    }
    switch (contentType) {
        case 'PublishedDatasource':
            return siteUrls.datasourceUrl(id);
        case 'Flow':
            return siteUrls.flowUrl(id);
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'WebDataConnector':
            return siteUrls.catalogDatabaseUrl(id);
        case 'VirtualConnection':
            return siteUrls.virtualConnectionUrl(id);
        case 'VirtualConnectionTable':
            return siteUrls.virtualConnectionTableUrl(id);
        case 'DatabaseTable':
            return siteUrls.catalogTableUrl(id);
        case 'Column':
            if (parentType === 'VirtualConnectionTable') {
                return siteUrls.virtualConnectionTableLineageFieldUrl(parentId !== null && parentId !== void 0 ? parentId : '', id);
            }
            if (parentType === 'CustomSQLTable' || parentType === 'DatabaseTable') {
                return siteUrls.catalogTableColumnUrl(parentId !== null && parentId !== void 0 ? parentId : '', id);
            }
            return undefined;
        case 'Field':
            if (parentType === 'PublishedDatasource' || parentType === 'datasource') {
                return siteUrls.datasourceLineageFieldUrl(parentId !== null && parentId !== void 0 ? parentId : '', id);
            }
            if (parentType === 'Workbook' || parentType === 'workbook') {
                return siteUrls.workbookLineageFieldUrl(parentId !== null && parentId !== void 0 ? parentId : '', id);
            }
            if (parentType === 'Flow' || parentType === 'flow') {
                return siteUrls.flowLineageFieldUrl(parentId !== null && parentId !== void 0 ? parentId : '', id);
            }
            return undefined;
        default:
            return undefined;
    }
}
function getIdForContentURL(asset) {
    if (!asset) {
        return undefined;
    }
    if ('vizportalUrlId' in asset) {
        return asset.vizportalUrlId;
    }
    return asset.id;
}
function buildLabelContentItemFromLabelFragment(label, controls) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return {
        contentId: (_a = label.asset) === null || _a === void 0 ? void 0 : _a.id,
        contentLuid: (_b = label.asset) === null || _b === void 0 ? void 0 : _b.luid,
        contentName: (_d = (_c = label.asset) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : undefined,
        contentType: (_f = (_e = label.asset) === null || _e === void 0 ? void 0 : _e.__typename) !== null && _f !== void 0 ? _f : null,
        contentIcon: (_k = (0, LabelHelpers_1.assetIconForType)((_h = (_g = label.asset) === null || _g === void 0 ? void 0 : _g.__typename) !== null && _h !== void 0 ? _h : null, ((_j = label.asset) === null || _j === void 0 ? void 0 : _j.__typename) === 'Column' ? label.asset.remoteType : undefined)) !== null && _k !== void 0 ? _k : undefined,
        subjectArea: (_l = label.asset) === null || _l === void 0 ? void 0 : _l.__typename,
        contentUrl: urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, (_m = label.asset) === null || _m === void 0 ? void 0 : _m.__typename, getIdForContentURL(label.asset), ((_o = label.asset) === null || _o === void 0 ? void 0 : _o.__typename) === 'Column' ? (_p = label.asset.table) === null || _p === void 0 ? void 0 : _p.id : undefined, ((_q = label.asset) === null || _q === void 0 ? void 0 : _q.__typename) === 'Column' ? (_r = label.asset.table) === null || _r === void 0 ? void 0 : _r.__typename : undefined),
        remoteType: ((_s = label.asset) === null || _s === void 0 ? void 0 : _s.__typename) === 'Column' ? label.asset.remoteType : undefined,
    };
}
function buildParentLabelContentItemFromLabelFragment(label, controls) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (((_a = label.asset) === null || _a === void 0 ? void 0 : _a.__typename) !== 'Column') {
        return undefined;
    }
    return {
        contentId: (_b = label.asset.table) === null || _b === void 0 ? void 0 : _b.id,
        contentType: ((_c = label.asset.table) === null || _c === void 0 ? void 0 : _c.__typename) === undefined || ((_d = label.asset.table) === null || _d === void 0 ? void 0 : _d.__typename) === 'CustomSQLTable'
            ? null
            : (_e = label.asset.table) === null || _e === void 0 ? void 0 : _e.__typename,
        contentName: (_g = (_f = label.asset.table) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : undefined,
        contentUrl: urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, (_h = label.asset.table) === null || _h === void 0 ? void 0 : _h.__typename, (_j = label.asset.table) === null || _j === void 0 ? void 0 : _j.id, undefined, undefined),
    };
}
function buildInheritedByLabelContentItemFromLabelFragment(label, controls, item, inheritedByCandidates) {
    var _a, _b, _c;
    if (!inheritedByCandidates || ((_a = label.asset) === null || _a === void 0 ? void 0 : _a.__typename) !== 'Column') {
        return undefined;
    }
    const inheritedBy = inheritedByCandidates
        .filter(inheritedByCandidate => {
        const candidateAsFlow = inheritedByCandidate;
        const candidateAsColumnOrField = inheritedByCandidate;
        if (candidateAsFlow.parentFields !== undefined) { // Flow
            return candidateAsFlow.parentFields.some(parentField => { var _a, _b; return parentField.__typename === 'FlowColumnInputField' && ((_a = parentField.column) === null || _a === void 0 ? void 0 : _a.luid) === ((_b = label.asset) === null || _b === void 0 ? void 0 : _b.luid); });
        }
        else if (candidateAsColumnOrField.upstreamColumns !== undefined) { // Column and Field
            return candidateAsColumnOrField.upstreamColumns.some(column => { var _a; return (column === null || column === void 0 ? void 0 : column.luid) === ((_a = label.asset) === null || _a === void 0 ? void 0 : _a.luid); });
        }
        else {
            return false;
        }
    })
        .shift();
    return inheritedBy
        ? {
            contentId: inheritedBy.id,
            contentType: null,
            contentName: (_b = inheritedBy.name) !== null && _b !== void 0 ? _b : undefined,
            contentUrl: inheritedBy.__typename === 'Column'
                ? urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, 'Column', inheritedBy.id, getIdForContentURL(inheritedBy.table), (_c = inheritedBy.table) === null || _c === void 0 ? void 0 : _c.__typename)
                : urlForContentType(controls === null || controls === void 0 ? void 0 : controls.siteUrls, 'Field', inheritedBy.id, item === null || item === void 0 ? void 0 : item.contentId, item === null || item === void 0 ? void 0 : item.subjectArea),
            subjectArea: inheritedBy.__typename === 'Column' ? 'Column' : 'Field',
        }
        : undefined;
}
function convertLabelFragmentToRenderLabelWarning(label, controls, item, inheritedByCandidates) {
    var _a, _b;
    return {
        type: label.value,
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : undefined,
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls),
        parent: buildParentLabelContentItemFromLabelFragment(label, controls),
        severe: label.isElevated,
        inheritedBy: buildInheritedByLabelContentItemFromLabelFragment(label, controls, item, inheritedByCandidates),
    };
}
function convertLabelFragmentToRenderLabelCert(label, controls) {
    var _a, _b;
    return {
        type: label.value,
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : undefined,
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls),
    };
}
function convertLabelFragmentToRenderLabelCustom(label, controls) {
    var _a, _b;
    return {
        type: label.value,
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : undefined,
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls),
    };
}
function convertLabelFragmentToRenderLabelSensitivity(label, controls, downstreamItem, inheritedByCandidates) {
    var _a, _b;
    return {
        severe: label.isElevated,
        type: label.value,
        active: label.isActive,
        author: (_a = label.author) !== null && _a !== void 0 ? _a : undefined,
        message: (_b = label.message) !== null && _b !== void 0 ? _b : '',
        updatedAt: catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(label.updatedAt)),
        content: buildLabelContentItemFromLabelFragment(label, controls),
        parent: buildParentLabelContentItemFromLabelFragment(label, controls),
        inheritedBy: buildInheritedByLabelContentItemFromLabelFragment(label, controls, downstreamItem, inheritedByCandidates),
    };
}
function getParentedItems(controls, includeParented, parentedItems) {
    const parentedWarnings = [];
    const parentedCertifications = [];
    const parentedSensitivities = [];
    const parentedCustom = new Map();
    if (parentedItems && includeParented) {
        parentedItems.forEach((parentedItem) => {
            var _a, _b, _c;
            const currGrouped = (0, LabelHelpers_1.groupBy)(parentedItem.labels, (key) => key.category);
            const currParentedWarnings = (_a = currGrouped.get('WARNING')) === null || _a === void 0 ? void 0 : _a.map(label => {
                return convertLabelFragmentToRenderLabelWarning(label, controls);
            });
            const currParentedCertifications = (_b = currGrouped
                .get('CERTIFICATION')) === null || _b === void 0 ? void 0 : _b.map(label => {
                return convertLabelFragmentToRenderLabelCert(label, controls);
            });
            const currParentedSensitivities = (_c = currGrouped
                .get('SENSITIVITY')) === null || _c === void 0 ? void 0 : _c.map(label => {
                return convertLabelFragmentToRenderLabelSensitivity(label, controls);
            });
            if (currParentedWarnings) {
                parentedWarnings.push(...currParentedWarnings);
            }
            if (currParentedCertifications) {
                parentedCertifications.push(...currParentedCertifications);
            }
            if (currParentedSensitivities) {
                parentedSensitivities.push(...currParentedSensitivities);
            }
            currGrouped === null || currGrouped === void 0 ? void 0 : currGrouped.forEach((labels, category) => {
                var _a;
                const parentedLabelsForCustomCategory = (_a = parentedCustom.get(category)) !== null && _a !== void 0 ? _a : [];
                !(0, LabelCategories_1.isBuiltInLabelCategory)(category)
                    ? parentedCustom.set(category, parentedLabelsForCustomCategory.concat(labels.map(label => {
                        return convertLabelFragmentToRenderLabelCustom(label, controls);
                    })))
                    : undefined;
            });
        });
    }
    return { parentedWarnings, parentedCertifications, parentedSensitivities, parentedCustom };
}
function convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, parentedItems, includeParented, includeUpstream, inheritedByCandidates }) {
    var _a, _b;
    if (!upstreamLabels && !parentedItems) {
        return {};
    }
    const upstreamGrouped = upstreamLabels && includeUpstream
        ? (0, LabelHelpers_1.groupBy)(upstreamLabels, (key) => key.category)
        : undefined;
    const upstreamWarnings = upstreamGrouped
        ? (_a = upstreamGrouped.get('WARNING')) === null || _a === void 0 ? void 0 : _a.map(label => {
            return convertLabelFragmentToRenderLabelWarning(label, controls, item, inheritedByCandidates);
        })
        : undefined;
    const upstreamSensitivities = upstreamGrouped
        ? (_b = upstreamGrouped.get('SENSITIVITY')) === null || _b === void 0 ? void 0 : _b.map(label => {
            return convertLabelFragmentToRenderLabelSensitivity(label, controls, item, inheritedByCandidates);
        })
        : undefined;
    const upstreamCustom = new Map();
    upstreamGrouped === null || upstreamGrouped === void 0 ? void 0 : upstreamGrouped.forEach((labels, category) => {
        !(0, LabelCategories_1.isBuiltInLabelCategory)(category)
            ? upstreamCustom.set(category, labels.map(label => {
                return convertLabelFragmentToRenderLabelCustom(label, controls);
            }))
            : undefined;
    });
    const { parentedWarnings, parentedCertifications, parentedSensitivities, parentedCustom } = getParentedItems(controls, includeParented, parentedItems);
    const hydratedWarnings = {
        category: 'warning',
        categoryType: 'warning',
        content: item,
        kind: 'hydrated',
        upstream: upstreamWarnings ? { category: 'warning', labels: upstreamWarnings } : undefined,
        parented: parentedWarnings.length > 0 ? { category: 'warning', labels: parentedWarnings } : undefined,
    };
    const hydratedCertifications = {
        category: 'certification',
        categoryType: 'certification',
        content: item,
        kind: 'hydrated',
        parented: parentedCertifications.length > 0
            ? { category: 'certification', labels: parentedCertifications }
            : undefined,
    };
    const hydratedSensitivities = {
        category: 'sensitivity',
        categoryType: 'sensitivity',
        content: item,
        kind: 'hydrated',
        upstream: upstreamSensitivities ? { category: 'sensitivity', labels: upstreamSensitivities } : undefined,
        parented: parentedSensitivities.length > 0 ? { category: 'sensitivity', labels: parentedSensitivities } : undefined,
    };
    const hydratedCustom = new Map();
    const customCategories = new Set([...upstreamCustom.keys()].concat([...parentedCustom.keys()]));
    customCategories.forEach((category) => {
        const upstreamLabels = upstreamCustom.get(category);
        const parentedLabels = parentedCustom.get(category);
        hydratedCustom.set(category, {
            category: category,
            categoryType: 'custom',
            content: item,
            kind: 'hydrated',
            upstream: upstreamLabels ? { category: category, labels: upstreamLabels } : undefined,
            parented: parentedLabels ? { category: category, labels: parentedLabels } : undefined,
        });
    });
    return {
        certifications: hydratedCertifications,
        warnings: hydratedWarnings,
        sensitivities: hydratedSensitivities,
        customLabels: hydratedCustom,
    };
}
exports.convertLabelsFragmentIntoRenderProps = convertLabelsFragmentIntoRenderProps;
//# sourceMappingURL=lazyQueryHelper.js.map